function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import _ from 'underscore';
import $ from 'jquery';
import Backbone from '@polleverywhere/backbone';

var Base = /*#__PURE__*/function (_Backbone$View) {
  _inheritsLoose(Base, _Backbone$View);

  var _proto = Base.prototype;

  _proto.include = function include(module) {
    _.extend(this, module(this));

    if (this.mixinsInitialized) {
      this.trigger('init:mixin');
    }

    return this;
  };

  function Base(options) {
    var _this;

    if (options === void 0) {
      options = {};
    }
    /**
     * WARNING there's a nasty hack in _ensureElement below
     * related to this
     */


    _this = _Backbone$View.apply(this, arguments) || this; // Set the page title if we're given one.

    if (options.title != null) {
      _this.title = options.title;
    } // Override the template if specified


    if (options.template != null) {
      _this.template = options.template;
    } // Tell the router what the title of our window should be.


    if (_this.title) {
      _this.app.title(_this.title);
    } // Trigger this after initialize (superclass runs that)


    _this.trigger('init:mixin');

    _this.mixinsInitialized = true;
    return _this;
  }
  /**
   * WARNING HACK TODO
   * Yikes, so we rely on modifying `this` before `initialize` is called
   * BUT es6 doesn't allow modifying `this` before `super` in the constructor
   * And backbone runs initialize as part of the `constructor` so we're in a bind
   * Hence, we are hacking it by hijacking this `_ensureElement` method which
   * is called before `initialize`
   * `preinitialize` would be cleaner, but then every subclass must use `super`
   * in that method which makes them less clean... :(
   */


  _proto._ensureElement = function _ensureElement() {
    /**
     * Set the app for this view to the base application
     * that PollEv.Router.Base sets up in its initialize method.
     */
    if (!this.app) {
      this.app = PollEv.app;
    }
    /**
     * TODO - Figure out how to show the full namespace
     * of the view that's being rendered (and not just the prototype name)
     * Make it easier for non-lib devs to find views.
     */


    this.app.log('Constructing View', this);
    /**
     * make sure we have an external events hash
     * if the child class hasn't defined one
     */

    if (this.appEvents == null) {
      this.appEvents = {};
    } // keep track of subviews so that we can clean it up when removing


    this.subViews = [];

    if (this.mixins) {
      for (var _i = 0, _Array$from = Array.from(_.result(this, 'mixins')); _i < _Array$from.length; _i++) {
        var Mixin = _Array$from[_i];
        this.include(Mixin);
      }
    } // Actually call the Backbone.View#_ensureElement method


    _Backbone$View.prototype._ensureElement.call(this);
  }
  /**
   * Listen to a list of events and fire callback only once
   */
  ;

  _proto.listenToChanges = function listenToChanges(model, attributes, callback) {
    attributes = attributes.split(/\s+/);
    this.listenTo(model, 'change', function (model) {
      var changedAttributes = _.keys(model.changed);

      if (_.intersection(changedAttributes, attributes).length) {
        callback.apply(this, [model]);
      }
    });
  };

  _proto.pageTitle = function pageTitle() {
    return _.result(this, 'title');
  };

  _proto._configureAppEvents = function _configureAppEvents() {
    for (var action in this.appEvents) {
      var handler = this.appEvents[action];

      try {
        var method = this[handler];

        if (_.isFunction(handler)) {
          method = handler;
        }

        this.app.on(action, method, this);
      } catch (error) {
        var name = "'" + ((this.constructor != null ? this.constructor.name : undefined) || '') + "'";
        var message = "View " + name + " has no method named '" + handler + "'. It cannot be registered as a handler for application events.";
        throw new Error(message);
      }
    }
  };

  _proto.delegateEvents = function delegateEvents(events) {
    _Backbone$View.prototype.delegateEvents.apply(this, arguments);

    this._configureAppEvents();
  };

  _proto.undelegateEvents = function undelegateEvents() {
    _Backbone$View.prototype.undelegateEvents.apply(this, arguments);

    this.app.log('Undelegating Events...');
    this.app.log('Events before undelegation: ', _.flatten(_.values(this.app._events)).length);

    for (var action in this.appEvents) {
      var handler = this.appEvents[action];
      var method = this[handler];

      if (_.isFunction(handler)) {
        method = handler;
      }

      this.app.off(action, method, this);
    }

    this.app.log('Events after undelegation: ', _.flatten(_.values(this.app._events)).length);
  } // Helper for appending a view and tracking it for cleanup
  ;

  _proto.appendView = function appendView(selector, view, mode) {
    if (mode === void 0) {
      mode = 'append';
    }

    var els;
    this.subViews = this.subViews.concat(view); // support multiple views

    if (_.isArray(view)) {
      els = _.map(view, function (v) {
        return v.render().$el;
      });
    } else {
      els = view.render().$el;
    }

    if (selector instanceof $) {
      return selector[mode](els);
    } else {
      return this.$(selector)[mode](els);
    }
  };

  _proto.removeSubViews = function removeSubViews() {
    Array.from(this.subViews).map(function (view) {
      return view.remove();
    });
  };

  _proto.remove = function remove() {
    this.undelegateEvents();
    this.removeSubViews();

    _Backbone$View.prototype.remove.apply(this, arguments);
  };

  _proto.renderTemplate = function renderTemplate(template, opts) {
    if (template === void 0) {
      template = this.template;
    }

    if (opts === void 0) {
      opts = {};
    }

    this.app.log('Rendering Template', template);

    if (_.isFunction(template)) {
      this.$el.html(template(opts));
    } else {
      // eslint-disable-next-line
      this.$el.html(JST[template](opts));
    }
  };

  _proto.renderTitle = function renderTitle() {
    this.$('.title').text(this.pageTitle());
    this.app.title(this.pageTitle());
  };

  _proto._ = function _(subSelector) {
    var parent;

    if (/--/.test(this.className)) {
      parent = this.className.substr(0, this.className.lastIndexOf('--'));
    } else {
      parent = this.className;
    }

    return this.$("." + parent + "--" + subSelector);
  };

  return Base;
}(Backbone.View);

export { Base as default };